module.exports = __webpack_public_path__ + "static/media/Portal_Logo.179e3c3e.svg";